import { render, staticRenderFns } from "./role.vue?vue&type=template&id=7a482c04&scoped=true&"
import script from "./role.vue?vue&type=script&lang=js&"
export * from "./role.vue?vue&type=script&lang=js&"
import style0 from "./role.vue?vue&type=style&index=0&id=7a482c04&scoped=true&lang=css&"
import style1 from "./role.vue?vue&type=style&index=1&id=7a482c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a482c04",
  null
  
)

export default component.exports